import React from 'react';
import Modal from 'react-modal';
// import { useTheme } from '../../../hooks/useTheme';

const AdditionalNote = ({ isVisible, onDecline, onAccept, additionalNote }) => {
    // const { isDarkMode } = useTheme();
    
    return (
        <Modal
            isOpen={isVisible}
            onRequestClose={onDecline}
            className="fixed inset-0 flex items-end justify-center bg-black bg-opacity-50"
        >
            <div className={`w-full max-h-[70%] min-h-[70%] bg-white dark:bg-gray-800 rounded-t-lg p-4`}> 
                <div className="border-b border-gray-300 dark:border-gray-600 pb-2 text-center">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Please Note!</h2>
                </div>
                
                <div className="overflow-auto max-h-[50vh] p-4">
                    {additionalNote?.length > 0 && additionalNote.map((message, index) => (
                        <p key={index} className="text-sm text-gray-700 dark:text-gray-300 py-2">
                            {message}
                        </p>
                    ))}
                </div>
                
                <div className="flex justify-between border-t border-gray-300 dark:border-gray-600 pt-4 gap-2">
                    <button
                        onClick={onDecline}
                        className="flex-1 px-4 py-2 border border-gray-500 text-gray-700 dark:text-gray-300 dark:border-gray-400 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onAccept}
                        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                    >
                        Okay
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default AdditionalNote;